import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { LayoutService } from './layout.service';
@Injectable({
    providedIn: 'root'
})

export class SharedService {
    
    constructor(private dataService: LayoutService) { }
    IsRoleAccess(featureName, functionName, operationName): boolean {
        if (!!this.dataService.userRoleData && Object.keys(this.dataService.userRoleData).length > 0) {
            let featureFunctions = this.dataService.userRoleData.find(x => x.featureName == featureName);
            let functions;
            if (!!featureFunctions && !!featureFunctions.functions) {
                functions = featureFunctions.functions.find(x => x.functionName == functionName);
            }
            if (!!functions && !!functions.permissions) {
                let result = functions.permissions.find(c => c.permissionName == operationName);
                if (!!result) {
                    return result.isAllowed;
                }
            }
        } else {
            return true;
        }
    }
    IsRouteAccess(featureName): boolean {
        if (!!this.dataService.userRoleData && Object.keys(this.dataService.userRoleData).length > 0) {
            let featureFunctions = this.dataService.userRoleData.find(x => x.featureName == featureName);
            if (!!featureFunctions && featureFunctions.isEnabled) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
}